import { Plan } from '@accedo/one-plugin-sdk';
import { t } from 'i18next';
import { FC } from 'react';

import {
  PlanPickerGrid,
  PlanPickerMainText,
  PlanPickerSubText,
} from '#/plugins/paywall/components';
import { translatePrice } from '#/plugins/paywall/utils';

import { ReceiptButton } from './styled';

interface Props extends Plan {
  onPlanChange: () => void;
}

export const SelectedPlan: FC<Props> = ({
  title,
  price,
  currency,
  duration,
  onPlanChange,
}) => {
  return (
    <PlanPickerGrid>
      <div>
        <PlanPickerMainText>{title}</PlanPickerMainText>
        <PlanPickerSubText>
          {translatePrice(price, currency, duration)}
        </PlanPickerSubText>
      </div>
      <ReceiptButton
        $hasBigText
        data-testid="selected-plan-receipt-button"
        onClick={onPlanChange}
      >
        {t('iap.selectedPlan.changePlan')}
      </ReceiptButton>
    </PlanPickerGrid>
  );
};
